<template>
  <div
    class="face-validate"
    :class="{ 'show-text': showText }"
    @click.stop.prevent="handleToast"
  >
    <fps-icon class="icon" type="photo-verify" color="#409AFF" />
    <span>{{$t('upgrade_page_views_player_list_index_177')}}</span>
  </div>
</template>

<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex'

export default {
  props:{
    nickname: String,
    userUuid: String,
    showText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods:{
    handleToast() {
      const { userInfo, userUuid, nickname } = this
      let totastMes = i18n.t('components_facevalidate_index_1784', [nickname])
      if (userInfo && userUuid && userInfo.uuid == userUuid) {
        totastMes = i18n.t('components_facevalidate_index_1785')
      }
      this.$message({
        dangerouslyUseHTMLString: true,
        message: totastMes,
      })
    }
  },
}
</script>

<style lang="scss" scoped>
  .face-validate {
    padding: 2px;
    cursor: pointer;
    span {
      display: none;
    }
    &.show-text {
      @include flex;
      padding: 2px 8px 2px 6px;
      border-radius: 20px;
      background: #E0EFFF;
      color: $color-gray-1;
      font-size: 12px;
      line-height: 12px;
      span {
        display: block;
        margin-left: 2px;
      }
    }
  }
  // i {
  //   width: 15px;
  //   cursor: pointer;
  //   color: #409AFF;
  //   margin-left: 3.5px;
  // }
</style>
